
document.addEventListener("DOMContentLoaded", function () {
  // service lacation modal 
  const drawer = document.querySelector(".servive_drawer");
  const closeBtn = document.querySelector(".servive_drawer_close");
  const overlay = document.querySelector(".servive_drawer_overlay");
  const serviceModalBtn = document.querySelector(".product__installation-check");
  
  serviceModalBtn?.addEventListener("click", () =>
    toggleDrawer(true)
  );

  closeBtn?.addEventListener("click", () =>
    toggleDrawer(false)
  );

  overlay?.addEventListener("click", () =>
    toggleDrawer(false)
  );

  function toggleDrawer(active) {
    const overflow = active ? "hidden" : "auto";
    document.body.style.overflow = overflow;
    drawer.classList.toggle("is--active", active);
    overlay.classList.toggle("is--active", active);
  }

  // video autoplay for free installation video
  const installationVideo = document.querySelector(".product__installation-video");
  const installationVideoOverlay = document.querySelector(".installation-video-overlay");
  if (installationVideo && installationVideoOverlay) {
    installationVideoOverlay.addEventListener("click", () => {
      installationVideo.play();
      installationVideo.controls = true;
      installationVideoOverlay.style.display = "none";
    });
  };
});


